// extracted by mini-css-extract-plugin
export var black = "_3t-6";
export var brand = "_3t-1";
export var ddefault = "_3t-0";
export var error = "_3t-3";
export var gray = "_3t-2";
export var highContrast = "_3t-8";
export var outline = "_3t-7";
export var success = "_3t-5";
export var warning = "_3t-4";